import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { environment } from "./../../environments/environment";

import { HelperServiceProvider } from "./helper.service";

@Injectable()
export class APIServiceProvider {
  private apiUrl: string = environment.API_URL;

  constructor(
    private http: HttpClient,
    public helperService: HelperServiceProvider
  ) {}

  // Get & Post for Authenticated APIs
  get(api_url: string, params?: any, full_api?, loader?) {
    let headerInfo: any = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("gp_token")
    };

    let httpOptions = {
      headers: new HttpHeaders(headerInfo)
    };

    let finalAPI = this.apiUrl + api_url;

    if (typeof loader === "undefined" || loader === null) {
      this.helperService.showLoader("Loading..");
    }

    if (typeof full_api !== "undefined" && full_api !== null) {
      finalAPI = full_api;
    }

    return this.http.get(finalAPI, httpOptions);
  }

  post(api_url, data?, full_api?, loader?) {
    let headerInfo: any = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("gp_token")
    };

    let httpOptions = {
      headers: new HttpHeaders(headerInfo)
    };

    let finalAPI = this.apiUrl + api_url;

    if (typeof full_api !== "undefined" && full_api !== null) {
      finalAPI = full_api;
    }

    if (typeof loader === "undefined" || loader === null) {
      this.helperService.showLoader("Loading..");
    }

    return this.http.post(finalAPI, data, httpOptions);
  }

  postMultiPart(api_url, data?, full_api?, loader?) {
    let headerInfo: any = { 
      Authorization: "Bearer " + localStorage.getItem("gp_token")
    };

    let httpOptions = {
      headers: new HttpHeaders(headerInfo)
    };

    let finalAPI = this.apiUrl + api_url;

    if (typeof full_api !== "undefined" && full_api !== null) {
      finalAPI = full_api;
    }

    if (typeof loader === "undefined" || loader === null) {
      this.helperService.showLoader("Loading..");
    }

    return this.http.post(finalAPI, data, httpOptions);
  }


  put(api_url, data?, full_api?) {
    let headerInfo: any = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("gp_token")
    };

    let httpOptions = {
      headers: new HttpHeaders(headerInfo)
    };

    let finalAPI = this.apiUrl + api_url;

    if (typeof full_api !== "undefined") {
      finalAPI = full_api;
    }

    return this.http.put(finalAPI, data, httpOptions);
  }

  login(api, data) {
    return this.http.post(this.apiUrl + api, data);
  }

  sendToKafka(api_url, data) {
    let headerInfo: any = {
      "Content-Type": "application/vnd.kafka.json.v2+json"
    };

    let httpOptions = {
      headers: new HttpHeaders(headerInfo)
    };

    let processedData: any = [];

    for (let i = 0; i < data.length; i++) {
      processedData[i] = {
        key: parseInt(data[i].user_id),
        value: data[i]
      };

      processedData[i].value.timestamp = parseInt(
        processedData[i].value.timestamp
      );
    }

    let sendData: any = {
      records: processedData
    };

    return this.http.post(api_url, sendData, httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/common/services/api.service.ts